import ImagingResultPreview from '@/src/pages/Doctor/Encounter/Manage Orders/Modals/ImagingResultPreview'
import LabResultPreview from '@/src/pages/Doctor/Encounter/Manage Orders/Modals/LabResultPreview'
import LabResultDetails from '@/src/pages/PDirectory/Result/Modals/labResultDetails'
import { AddItem, EditItem, RemoveItem } from '@admin/Billing/Modals'
import { Choice } from '@directory/DemoGraphy/Modals/Choice'
import { Emergency } from '@directory/DemoGraphy/Modals/Emergency'
import CodeModal from '@directory/Intake/intakeForm/CodeModal'
import { ReconciliationDetails } from '@doctor/Encounter/Admission/Modals/Details'
import { AddMAR, EditMAR, MARDetails } from '@doctor/Encounter/M.A.R/Modals'
import AddImagingOrder from '@doctor/Encounter/Manage Orders/Modals/AddImagingOrder'
import EditImagingOrder from '@doctor/Encounter/Manage Orders/Modals/EditImagingOrder'
import AddLabOrder from '@doctor/Encounter/Manage Orders/Modals/AddLab'
import EditLabOrder from '@doctor/Encounter/Manage Orders/Modals/EditLab'
import AllergyWarning from '@doctor/Encounter/Manage Orders/Modals/AllergyWarning'
import { CancelAllImagingOrders, CancelImagingOrder } from '@doctor/Encounter/Manage Orders/Modals/CancelImagingOrder'
import { CanceAllLabOrders, CancelLabOrder } from '@doctor/Encounter/Manage Orders/Modals/DeleteLab'
import ImagingDetails from '@doctor/Encounter/Manage Orders/Modals/ImagingDetails'
import LabDetails from '@doctor/Encounter/Manage Orders/Modals/LabDetails'
import { PreviewTemplate } from '@doctor/Encounter/Manage Orders/Modals/Procedure/ConsentForm/PreviewTemplate'
import AddAdmissionOrder from '@pages/AdmissionOrder/Modal/AddAdmisionOrder'
import { DispenseDetail } from '@pharmacist/Dispense'
import { PrepareUnit, PrescribeDis, QueryMed, VerifyMedication } from '@pharmacist/MedOrder'
import type { ComponentType } from 'react'
import { Fragment } from 'react/jsx-runtime'
import { MedecationDetail } from '../../pages/Pharmacist/Medication/Modals/MedecationDetail'
import { useModalStore } from './modalstore'

export enum DOCTOR_MODAL_TYPE {
  ADD_MAR_MODAL = 'ADD_MAR_MODAL',
  EDIT_MAR_MODAL = 'EDIT_MAR_MODAL',
  DETAILS_MAR_MODAL = 'DETAILS_MAR_MODAL',
  DETAIL_PHARM_MEDICATION = 'DETAIL_PHARM_MEDICATION',
  DETAILS_RECONCILIATION_MODAL = 'DETAILS_RECONCILIATION_MODAL',
  ADD_ITEM = 'ADD_ITEM',
  EDIT_ITEM = 'EDIT_ITEM',
  REMOVE_ITEM = 'REMOVE_ITEM',
  ADD_ADMISSION_ORDER = 'ADD_ADMISSION_ORDER',
  UPDATE_CODE = 'UPDATE_CODE',
  QUERY_MED = 'QUERY_MED',
  DESPENSE_AS_PRESCRIBE = 'DESPENSE_AS_PRESCRIBE',
  PREPARE_DOSE = 'PREPARE_DOSE',
  COMPOUND_DOSE = 'COMPOUND_DOSE',
  DISPENSE_DETAIL = 'DISPENSE_DETAIL',
  VERIFY_MEDICATION = 'VERIFY_MEDICATION',
  EMERGENCY = 'EMERGENCY',
  CHOICE = 'CHOICE',
  PREVIEW_CONSENT_TEMPLATE = 'PREVIEW_CONSENT_TEMPLATE',
  ALLERGY_WARNING = 'ALLERGY_WARNING',
  ADD_LAB_ORDER = 'ADD_LAB_ORDER',
  EDIT_LAB_ORDER = 'EDIT_LAB_ORDER',
  LAB_DETAILS = 'LAB_DETAILS',
  LAB_RESULT_PREVIEW = 'LAB_RESULT_PREVIEW',
  LAB_RESULT_DETAILS = 'LAB_RESULT_DETAILS',
  CANCEL_ALL_LAB_ORDERS = 'CANCEL_ALL_LAB_ORDERS',
  CANCEL_LAB_ORDER = 'CANCEL_LAB_ORDER',
  // `IMAGING_DETAILS` stays unprefixed on purpose: it is read-only, and the encounter
  // write-lock (utils/encounterWriteGuard.ts) keys off the ADD_/CANCEL_/… name prefix.
  IMAGING_DETAILS = 'IMAGING_DETAILS',
  IMAGING_RESULT_PREVIEW = 'IMAGING_RESULT_PREVIEW',
  ADD_IMAGING_ORDER = 'ADD_IMAGING_ORDER',
  EDIT_IMAGING_ORDER = 'EDIT_IMAGING_ORDER',
  CANCEL_IMAGING_ORDER = 'CANCEL_IMAGING_ORDER',
  CANCEL_ALL_IMAGING_ORDERS = 'CANCEL_ALL_IMAGING_ORDERS'
}

const Modals = [
  {
    component: AddMAR,
    value: DOCTOR_MODAL_TYPE.ADD_MAR_MODAL
  },
  {
    component: EditMAR,
    value: DOCTOR_MODAL_TYPE.EDIT_MAR_MODAL
  },
  {
    component: MARDetails,
    value: DOCTOR_MODAL_TYPE.DETAILS_MAR_MODAL
  },
  {
    component: ReconciliationDetails,
    value: DOCTOR_MODAL_TYPE.DETAILS_RECONCILIATION_MODAL
  },
  {
    component: MedecationDetail,
    value: DOCTOR_MODAL_TYPE.DETAIL_PHARM_MEDICATION
  },
  {
    component: AddItem,
    value: DOCTOR_MODAL_TYPE.ADD_ITEM
  },
  {
    component: EditItem,
    value: DOCTOR_MODAL_TYPE.EDIT_ITEM
  },
  {
    component: RemoveItem,
    value: DOCTOR_MODAL_TYPE.REMOVE_ITEM
  },
  {
    component: AddAdmissionOrder,
    value: DOCTOR_MODAL_TYPE.ADD_ADMISSION_ORDER
  },
  {
    component: CodeModal,
    value: DOCTOR_MODAL_TYPE.UPDATE_CODE
  },
  {
    component: PrescribeDis,
    value: DOCTOR_MODAL_TYPE.DESPENSE_AS_PRESCRIBE
  },
  {
    component: QueryMed,
    value: DOCTOR_MODAL_TYPE.QUERY_MED
  },
  {
    component: PrepareUnit,
    value: DOCTOR_MODAL_TYPE.PREPARE_DOSE
  },
  {
    component: DispenseDetail,
    value: DOCTOR_MODAL_TYPE.DISPENSE_DETAIL
  },
  {
    component: PreviewTemplate,
    value: DOCTOR_MODAL_TYPE.PREVIEW_CONSENT_TEMPLATE
  },
  {
    component: VerifyMedication,
    value: DOCTOR_MODAL_TYPE.VERIFY_MEDICATION
  },
  {
    component: Emergency,
    value: DOCTOR_MODAL_TYPE.EMERGENCY
  },
  {
    component: Choice,
    value: DOCTOR_MODAL_TYPE.CHOICE
  },
  {
    component: AllergyWarning,
    value: DOCTOR_MODAL_TYPE.ALLERGY_WARNING
  },
  {
    component: AddLabOrder,
    value: DOCTOR_MODAL_TYPE.ADD_LAB_ORDER
  },
  {
    component: EditLabOrder,
    value: DOCTOR_MODAL_TYPE.EDIT_LAB_ORDER
  },
  {
    component: LabDetails,
    value: DOCTOR_MODAL_TYPE.LAB_DETAILS
  },
  {
    component: LabResultPreview,
    value: DOCTOR_MODAL_TYPE.LAB_RESULT_PREVIEW
  },
  {
    component: ImagingResultPreview,
    value: DOCTOR_MODAL_TYPE.IMAGING_RESULT_PREVIEW
  },
  {
    component: LabResultDetails,
    value: DOCTOR_MODAL_TYPE.LAB_RESULT_DETAILS
  },
  {
    component: CanceAllLabOrders,
    value: DOCTOR_MODAL_TYPE.CANCEL_ALL_LAB_ORDERS
  },
  {
    component: CancelLabOrder,
    value: DOCTOR_MODAL_TYPE.CANCEL_LAB_ORDER
  },
  {
    component: AddImagingOrder,
    value: DOCTOR_MODAL_TYPE.ADD_IMAGING_ORDER
  },
  {
    component: EditImagingOrder,
    value: DOCTOR_MODAL_TYPE.EDIT_IMAGING_ORDER
  },
  {
    component: ImagingDetails,
    value: DOCTOR_MODAL_TYPE.IMAGING_DETAILS
  },
  {
    component: CancelAllImagingOrders,
    value: DOCTOR_MODAL_TYPE.CANCEL_ALL_IMAGING_ORDERS
  },
  {
    component: CancelImagingOrder,
    value: DOCTOR_MODAL_TYPE.CANCEL_IMAGING_ORDER
  }
]

export const DoctorModal = () => {
  const { activeModal, closeModal } = useModalStore()

  return (
    <>
      {Modals?.map(({ component: Component, value }) => {
        const activeEntry = activeModal.find(({ modal }) => modal === value)
        const modalProps = (activeEntry?.modalProps as Record<string, any>) || {}
        const reset = modalProps.reset as (() => void) | undefined
        const isOpen = activeEntry != null
        const ModalComponent = Component as ComponentType<
          Record<string, unknown> & { isOpen?: boolean; onClose?: () => void }
        >

        return (
          <Fragment key={value}>
            {isOpen && (
              <ModalComponent
                isOpen={isOpen}
                key={value}
                onClose={() => {
                  closeModal(value, reset)
                }}
                {...modalProps}
              />
            )}
          </Fragment>
        )
      })}
    </>
  )
}
